import React from 'react';
import styled from 'styled-components';
import { RESPONSIVE, useResponsive } from '@services/responsiveProvider';
import EventList from '@features/eventList/components/EventList';
import EventSearchSidePanel from '@features/eventList/components/EventSearchSidePanel';

const EventListTemplate = () => {
  const responsive = useResponsive();
  return (
    <Container>
      { responsive === RESPONSIVE.DESKTOP && (
        <SidePanelWrapper>
          <EventSearchSidePanel />
        </SidePanelWrapper>
      ) }
      <EventList />
    </Container>
  );
};

export default EventListTemplate;

const Container = styled.div`
    display: flex;
`;

const SidePanelWrapper = styled.div`
    width: 351px;
    margin-right: 95px;
    min-width: 351px;
    max-width: 351px;
`;
